module.exports = __webpack_public_path__ + "static/img/fish18.dc8d689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish18.png
// module id = T8cX
// module chunks = 0